import type { RatingProps } from './Rating.types'
import cn from 'classnames'
import * as React from 'react'
import { Icon } from '../icon'
import styles from './Rating.module.css'

const S_SIZE = 16

function Rating({ rating, type = 'yellow', className, ...props }: RatingProps) {
  const validValues = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]
  const isRatingValid = validValues.includes(rating)

  if (!isRatingValid) {
    return null
  }

  const fullStars = Math.floor(rating)
  const halfStars = rating - fullStars

  return (
    <div
      className={cn(
        styles.rating,
        {
          [styles.typeNeutral]: type === 'neutral',
          [styles.typeYellow]: type === 'yellow',
        },
        className,
      )}
      {...props}
    >
      {Array.from({ length: fullStars }).map((_, index) => (
        <Icon glyph="StarFilled" key={`full-${index}`} size={S_SIZE} />
      ))}
      {halfStars > 0 && <Icon glyph="StarHalfFilled" size={S_SIZE} />}
    </div>
  )
}

Rating.displayName = 'Rating'

export default Rating
